import { FETCH_HOMEPAGE, FETCH_MAGAZINE_DETAIL } from '../actions/types';

const INITIAL_STATE = [];

export const magazineHomeReducer = (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case FETCH_HOMEPAGE:
			const { homepage } = action.payload;

			homepage.magazinesHome.forEach((magazine, key) => {
				state[key] = magazine;
			});

			return state;

		case FETCH_MAGAZINE_DETAIL:
			const { magazinesHome } = action.payload.magazine;

			magazinesHome.forEach((magazine, key) => {
				state[key] = magazine;
			});

			return state;

		default:
			return state;
	}
};
